import { React, useState, useEffect, useRef } from "react";
import "./button.css";

function Button({
  image,
  active,
  children,
  activation,
  isDisabled,
  isCorrect,
  colorActive,
  btnId,
  buttonStyle,
  style = {}
}) {
  let [isActive, setActive] = useState(false);
  let [activeClass, setActiveClass] = useState("dos-btn-active");
  let [idleClass, setIdleClass] = useState("dos-btn");

  const theme_settings = JSON.parse(localStorage.getItem("theme_settings_kn"));
  const buttonStyleUser = theme_settings?.button_style ?? "dos";

  const buttonRef = useRef(null);

  useEffect(() => {
    const el = buttonRef.current;
    if (!el) return;

    const applyStyle = () => {
      if (buttonStyleUser === "dos") {
        setIdleClass("dos-btn");
        setActiveClass("dos-btn-active");
      } else if (buttonStyleUser === "round-none-border") {
        setIdleClass("dos-btn-round-none-border");
        setActiveClass("dos-btn-active-round-none-border");
      } else if (buttonStyleUser === "round-border") {
        setIdleClass("dos-btn-round-border");
        setActiveClass("dos-btn-active-round-border");
      } else if (buttonStyleUser === "round") {
        const { offsetWidth, offsetHeight } = el;
        const isWide = offsetWidth > offsetHeight * 1.6;
        if (isWide) {
          setIdleClass("dos-btn-round-wide");
          setActiveClass("dos-btn-active-round-wide");
        } else {
          setIdleClass("dos-btn-round");
          setActiveClass("dos-btn-active-round");
        }
      }
    };

    applyStyle();

    const resizeObserver = new ResizeObserver(applyStyle);
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, [buttonStyleUser]);

  useEffect(() => {
    setActive(active);
  }, [active]);

  const handleButtonActive = () => {
    if (activation) return;
    setActive((current) => !current);
  };

  const checkActiveNotCorrect = () => {
    if (isCorrect) return `${idleClass} correct`;
    else return idleClass;
  };

  return (
    <button
      ref={buttonRef}
      className={isActive ? activeClass : checkActiveNotCorrect()}
      onClick={handleButtonActive}
      disabled={isDisabled}
      style={{ ...style }}
      id={btnId}
    >
      {image !== undefined && <img src={image} alt="" />}
      {children}
    </button>
  );
}

export default Button;